module.exports = __webpack_public_path__ + "img/car-side-bolt.37a44959.svg";